module.exports = __webpack_public_path__ + "media/footer-image.6a53caa7.png";